import { Component, OnInit, OnDestroy, ViewChild, TemplateRef } from '@angular/core';
import { AuthService } from '../core/auth/auth.service';
import { AppConfig } from 'src/config/app.config';
import { FormGroup, Validators, FormControl, AbstractControl } from '@angular/forms';
import { MESSAGE_CONSTS } from '../ValidationMessages';
import { dealerClaimData, ClaimType, ClaimStatus } from './dealerClaimData.model';
import { NxMessageToastService } from '@aposin/ng-aquila/message';
import { SortEvent, SortDirection } from '@aposin/ng-aquila/table';
import { RequestIntegrity } from '../core/request-integrety';
import { CustomErrorHandler } from '../core/custom-error-handler';
import { NotificationService } from '../core/notification.service';
import { Subscription } from 'rxjs';
import { saveAs } from 'file-saver';
import { ActivatedRoute } from '@angular/router';
import * as moment from 'moment';

@Component({
    selector: 'app-dealerclaim',
    templateUrl: './dealerclaim.component.html',
    styleUrls: ['./dealerclaim.component.css']
})
export class DealerclaimComponent implements OnInit, OnDestroy {
    _apiUrl: string;
    clientId: number;
    claimList: any[];
    Userrole: string;
    isSuccess: boolean;
    reqDecision: boolean;
    claimViewModalOpen: boolean = false;
    claimFormModalOpen: boolean = false;
    claimApproveRejectForm: FormGroup;
    claimRequestForm: FormGroup;
    selectedClaim: dealerClaimData = new dealerClaimData();
    public response: { dbPath: '' };
    invoiceUploadPath: string;
    vehicleImageUploadPaths: string[] = [];
    errorMessage: string;
    userPermission: any = {};
    ClaimTypes = ClaimType;
    ClaimStatuses = ClaimStatus;
    claimStatusList: string[];
    SelectedClaimStatus: typeof ClaimStatus;
    saveClaimText: string = 'Submit';
    saveClaimInProgress: boolean = false;
    acceptedPdfType: string = 'application/pdf';
    acceptedImageType: string = 'image/*';
    casesModalOpen: boolean = false;
    casesHasError: boolean = false;
    casesErrorMessage: string = '';
    casesList: any[] = [];

    count: number;
    pageNumber: number = 1;
    pageSize: number = 10;
    searchTerm: any = '';
    startDate: moment.Moment | null = null;
    endDate: moment.Moment | null = null;
    fileName: string = '';
    private notifSub: Subscription = new Subscription();

    constructor(
        private authService: AuthService,
        private appConfig: AppConfig,
        private messageToastService: NxMessageToastService,
        private requestIntegrity: RequestIntegrity,
        private errorHandler: CustomErrorHandler,
        private route: ActivatedRoute,
        private notifService: NotificationService
    ) {
        this._apiUrl = appConfig.baseUrl;
        this.clientId = parseInt(atob(localStorage.getItem('CLIENT_ID')));
        this.Userrole = atob(localStorage.getItem('userRole'));
        this.setUserPermission();
    }

    ngOnInit() {
        this.claimStatusList = Object.keys(ClaimStatus).filter(key => isNaN(+key));
        const statusParam = this.route.snapshot.queryParamMap.get('status');
        if (statusParam !== null) {
            this.SelectedClaimStatus = statusParam as any;
        }
        this.getAllClaims();
        this.notifService.pollNow();

        this.notifSub.add(
            this.notifService.newNotifications$.subscribe(() => this.getAllClaims())
        );
    }

    ngOnDestroy(): void {
        this.notifSub.unsubscribe();
    }

    prevPage() { this.pageNumber--; this.getAllClaims(); }
    nextPage() { this.pageNumber++; this.getAllClaims(); }
    goToPage(n: number) { this.pageNumber = n; this.getAllClaims(); }

    setUserPermission() {
        this.authService.userPermissions().subscribe(response => {
            if (response) this.userPermission = response;
        });
    }

    getAllClaims() {
        const status = this.SelectedClaimStatus == undefined ? '' : this.SelectedClaimStatus;
        const from = this.startDate ? this.startDate.format('LL') : '';
        const to = this.endDate ? this.endDate.format('LL') : '';
        this.authService.getList(
            `${this._apiUrl}/api/v1/DealerClaim?pageNumber=${this.pageNumber}&pageSize=${this.pageSize}&searchText=${this.searchTerm}&udf1=${status}&startDate=${from}&endDate=${to}`
        ).subscribe(response => {
            if (response) {
                this.claimList = response.body;
                var pagingProp = JSON.parse(response.headers.get('X-Pagination'));
                this.count = pagingProp.TotalCount;
                this.notifService.pollNow();
            }
        }, error => {
            console.error(error);
            this.handleError(error);
        });
    }

    exportToExcel() {
        const status = this.SelectedClaimStatus == undefined ? '' : this.SelectedClaimStatus;
        const from = this.startDate ? this.startDate.format('LL') : '';
        const to = this.endDate ? this.endDate.format('LL') : '';
        this.authService.getList(
            `${this._apiUrl}/api/v1/DealerClaim?pageNumber=-1&pageSize=10000&searchText=${this.searchTerm}&udf1=${status}&startDate=${from}&endDate=${to}`
        ).subscribe(response => {
            if (response) {
                const rows = (response.body || []).map((item: any) => ({
                    'Reference No.': item.transactionId || '',
                    'Dealer': item.dealerName || '',
                    'Claim Type': this.getClaimTypeName(item.claimType),
                    'Submitted On': item.submissionDate ? new Date(item.submissionDate).toLocaleDateString('en-GB') : '',
                    'Remark': item.remark || '',
                    'Status': item.status || ''
                }));
                import('xlsx').then(xlsx => {
                    const ws = xlsx.utils.json_to_sheet(rows);
                    const wb = xlsx.utils.book_new();
                    xlsx.utils.book_append_sheet(wb, ws, 'Dealer Claims');
                    this.fileName = `DealerClaims_${new Date().toLocaleDateString('en-GB').replace(/\//g, '-')}.xlsx`;
                    xlsx.writeFile(wb, this.fileName);
                });
            }
        }, error => {
            console.error(error);
        });
    }

    sortTable(sort: SortEvent) {
        this.claimList = this.claimList.sort((a, b) => {
            if (sort.active in a && sort.active in b) {
                return this.compare(a[sort.active], b[sort.active], sort.direction);
            }
            return 0;
        });
    }

    compare(a: number | string | Date, b: number | string | Date, direction: SortDirection) {
        return (a < b ? -1 : 1) * (direction === 'asc' ? 1 : -1);
    }

    claimARFormBuilder() {
        this.claimApproveRejectForm = new FormGroup({
            id: new FormControl(this.selectedClaim.id),
            workshopId: new FormControl(this.selectedClaim.workshopId),
            claimType: new FormControl(this.selectedClaim.claimType),
            invoicePdfPath: new FormControl(this.selectedClaim.invoicePdfPath),
            vehicleImagePaths: new FormControl(this.selectedClaim.vehicleImagePaths),
            clientId: new FormControl(this.selectedClaim.clientId),
            remark: new FormControl(this.selectedClaim.remark),
            dealerName: new FormControl(this.selectedClaim.dealerName),
            dealerCode: new FormControl(this.selectedClaim.dealerCode),
            approvedRemarks: new FormControl('', [Validators.required, Validators.pattern(MESSAGE_CONSTS.ALLOWED_SPECIALCHAR_REGEX)]),
            approvedby: new FormControl(''),
            approvedDate: new FormControl(''),
            status: new FormControl(''),
            transactionId: new FormControl(this.selectedClaim.transactionId),
            submissionDate: new FormControl(this.selectedClaim.submissionDate)
        });
    }

    claimRequestFormBuilder() {
        var transactionId = this.requestIntegrity.uuidv4();
        this.claimRequestForm = new FormGroup({
            workshopId: new FormControl(0),
            claimType: new FormControl('', [Validators.required]),
            invoicePdfPath: new FormControl('', [Validators.required]),
            vehicleImagePaths: new FormControl(''),
            remark: new FormControl('', [Validators.pattern(MESSAGE_CONSTS.ALLOWED_SPECIALCHAR_REGEX)]),
            clientId: new FormControl(this.clientId),
            status: new FormControl(0),
            transactionId: new FormControl(transactionId),
            hash: new FormControl(this.requestIntegrity.HashInput(transactionId))
        });
    }

    get ARFormControls() { return this.claimApproveRejectForm.controls; }
    get RequestFormControls() { return this.claimRequestForm.controls; }

    toggleClaimFormModal() {
        this.isSuccess = false;
        this.invoiceUploadPath = '';
        this.vehicleImageUploadPaths = [];
        this.claimRequestFormBuilder();
        this.claimFormModalOpen = !this.claimFormModalOpen;
    }

    toggleApproveRejectModal(approve: boolean, claim: any) {
        this.reqDecision = approve;
        this.isSuccess = false;
        this.selectedClaim = claim;
        this.claimViewModalOpen = !this.claimViewModalOpen;
        this.claimARFormBuilder();
        this.claimApproveRejectForm.patchValue({
            approvedDate: new Date(),
            status: approve ? ClaimStatus.Paid : ClaimStatus.Rejected
        });
        if (!approve) {
            this.claimApproveRejectForm.updateValueAndValidity();
        }
    }

    toggleClaimARModal() {
        this.claimViewModalOpen = !this.claimViewModalOpen;
    }

    openCasesModal() {
        this.casesModalOpen = false;
        this.getDealerCases();
    }

    closeCasesModal() {
        this.casesModalOpen = false;
    }

    getDealerCases() {
        this.casesHasError = false;
        this.casesErrorMessage = '';
        this.casesList = [];

        this.authService.getList(`${this._apiUrl}/api/v1/DealerClaim/cases`)
            .subscribe(response => {
                const body = response ? response.body : null;
                if (body && body.success === true && Array.isArray(body.data)) {
                    this.casesList = body.data;
                } else {
                    this.casesHasError = true;
                    this.casesErrorMessage = body && body.responsemsg
                        ? body.responsemsg
                        : 'Invalid cases response received.';
                    console.error('Unexpected cases API response:', body);
                }
                this.casesModalOpen = true;
            }, error => {
                this.casesHasError = true;
                this.casesErrorMessage = 'Failed to load cases. Please try again.';
                this.casesModalOpen = true;
                console.error('Cases API error:', error);
            });
    }

    saveClaim() {
        this.saveClaimInProgress = true;
        this.saveClaimText = 'Please Wait...';
        this.claimRequestForm.patchValue({ invoicePdfPath: this.invoiceUploadPath });
        if (this.vehicleImageUploadPaths.length > 0) {
            this.claimRequestForm.patchValue({ vehicleImagePaths: this.vehicleImageUploadPaths.join(',') });
        }
        this.claimRequestForm.updateValueAndValidity();

        if (this.claimRequestForm.valid) {
            this.authService.post(
                this._apiUrl + '/api/v1/DealerClaim',
                btoa(JSON.stringify(this.claimRequestForm.value))
            ).subscribe(response => {
                this.saveClaimInProgress = false;
                this.saveClaimText = 'Submit';
                this.isSuccess = true;
                this.getAllClaims();
            }, error => {
                this.saveClaimInProgress = false;
                this.saveClaimText = 'Submit';
                this.handleError(error);
            });
        } else {
            this.saveClaimInProgress = false;
            this.saveClaimText = 'Submit';
        }
    }

    saveClaimDecision() {
        this.saveClaimInProgress = true;
        this.saveClaimText = 'Please wait...';
        this.authService.put(
            this._apiUrl + '/api/v1/DealerClaim/' + this.claimApproveRejectForm.value.id,
            this.claimApproveRejectForm.value
        ).subscribe(response => {
            this.saveClaimInProgress = false;
            this.saveClaimText = 'Submit';
            this.isSuccess = true;
            this.getAllClaims();
        }, error => {
            this.saveClaimInProgress = false;
            this.saveClaimText = 'Submit';
            this.claimViewModalOpen = false;
            this.getAllClaims();
        });
    }

    public onInvoiceUploadFinished = (event) => {
        this.response = event;
        this.invoiceUploadPath = this.response.dbPath;
        this.claimRequestForm.patchValue({ invoicePdfPath: this.invoiceUploadPath });
    }

    public onVehicleImageUploadFinished = (event) => {
        this.response = event;
        if (event.dbPath) {
            this.vehicleImageUploadPaths.push(event.dbPath);
        }
    }

    download(path: string) {
        this.authService.export(this._apiUrl + `/api/v1/common/stream?filePath=${path}`)
            .subscribe(response => {
                if (response.size > 0) {
                    var filename = path.split(/_(.+)/)[1];
                    saveAs(response, filename);
                } else {
                    this.errorHandler.handleCustomError('File not found, Contact admin!!');
                }
            }, error => {
                this.errorHandler.handleCustomError(error);
            });
    }

    getClaimTypeName(type: number): string {
        switch (type) {
            case ClaimType.Damage: return 'Damage Claim';
            case ClaimType.Technician: return 'Technician Reimbursement';
            case ClaimType.Towing: return 'Towing Reimbursement';
            default: return '';
        }
    }

    handleError(error, custmsg: string = '') {
        if (error.error instanceof ErrorEvent) {
            this.errorMessage = `Error : ${error.error.message}`;
        } else {
            this.errorMessage = `Error : ${error.error}`;
        }
        this.messageToastService.open(this.errorMessage, { context: 'info', duration: 5000 });
    }

    get checkSaveDisable(): boolean {
        return this.claimApproveRejectForm.invalid || this.saveClaimInProgress;
    }

    get checkClaimFormDisable(): boolean {
        return this.claimRequestForm.invalid || this.saveClaimInProgress || !this.invoiceUploadPath;
    }

    get isDealer(): boolean {
        return this.Userrole === 'Dealer' || this.Userrole === 'WorkShop';
    }
}